import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { LayoutGrid, List, Search } from 'lucide-react';

interface DashboardControlsProps {
  viewMode: 'grid' | 'list';
  onViewModeChange: (mode: 'grid' | 'list') => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export function DashboardControls({
  viewMode,
  onViewModeChange,
  searchQuery,
  onSearchChange,
}: DashboardControlsProps) {
  useLanguage();
  return (
    <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 sm:gap-4 w-full">
      {/* Segmented Control Premium */}
      <div className="inline-flex bg-[#F3F4F6] rounded-[10px] p-1 gap-1">
        <button
          onClick={() => onViewModeChange('grid')}
          className={`
            flex items-center gap-2 px-[14px] py-[6px] rounded-[8px]
            text-[14px] font-semibold transition-all duration-200
            ${viewMode === 'grid' 
              ? 'bg-[#1F6BFF] text-white shadow-sm' 
              : 'text-[#374151] hover:bg-white/60'
            }
          `}
        >
          <LayoutGrid className="w-4 h-4" />
          {translateInterfaceText("Grade")}</button>
        <button
          onClick={() => onViewModeChange('list')}
          className={`
            flex items-center gap-2 px-[14px] py-[6px] rounded-[8px]
            text-[14px] font-semibold transition-all duration-200
            ${viewMode === 'list' 
              ? 'bg-[#1F6BFF] text-white shadow-sm' 
              : 'text-[#374151] hover:bg-white/60'
            }
          `}
        >
          <List className="w-4 h-4" />
          {translateInterfaceText("Lista")}</button>
      </div>

      {/* Campo de Busca Premium */}
      <div className="relative w-full sm:max-w-[360px]">
        <Search className="absolute left-[14px] top-1/2 -translate-y-1/2 w-4 h-4 text-[#9CA3AF]" />
        <input
          type="text"
          placeholder={translateInterfaceText("Buscar vídeos...")}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="
            w-full h-[42px] pl-10 pr-4 rounded-[10px]
            border border-[#E5E7EB] bg-white
            text-[14px] text-[#374151] placeholder:text-[#9CA3AF]
            focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10
            transition-all duration-200
          "
        />
      </div>
    </div>
  );
}
